import assetsUploader from './assets-uploader';

export default {
  assetsUploader,
};
